import $ from 'jquery';
import React from 'react';
import OptionPopupView from "views/common/OptionPopupView";
import { createRoot } from "react-dom/client";
import ChangePlanContent from '../../components/settings/ChangePlanContent';

const ChangePlanPopupView = OptionPopupView.extend({

    "pageName": "Change Plan Popup",

    initialize: function(options) {
        this._currentPlanType = options.currentPlanType || 'free';
        this._currentBillingCycle = options.currentBillingCycle || 'monthly';
        this._workspaceUsage = options.workspaceUsage || {};
        this._onConfirm = options.onConfirm;
        this._onCancelSubscription = options.onCancelSubscription;
        this._i18nModule = options.i18nModule;
        this._reactRoot = null;

        // Create content container for React component
        this.contentContainer$el = $('<div class="change-plan-popup-content"></div>');
        this.contentContainer$el.css("width", "calc(100% - 40px)");
        this.contentContainer$el.css("max-width", "880px");

        const contentView = {};
        contentView.$el = this.contentContainer$el;

        const viewOptions = {
            contentView: contentView,
            contentPosition: "text-not-white",
            addContentAfterEnhancement: true,
            displayTitle: false,
            id: "ChangePlanPopup"
        };

        OptionPopupView.prototype.initialize.call(this, viewOptions);
    },

    onPopupClosed: function() {
        if (this._reactRoot) {
            this._reactRoot.unmount();
            this._reactRoot = null;
        }
    },

    onConfirmTriggered: async function(targetPlanType) {
        if (this._onConfirm) {
            await this._onConfirm(targetPlanType);
        }
    },

    onCancelSubscriptionTriggered: async function() {
        if (this._onCancelSubscription) {
            await this._onCancelSubscription();
        }
    },

    onCancelTriggered: function() {
        this.close();
    },

    _renderReactComponent: function() {
        if (this._reactRoot) {
            this._reactRoot.unmount();
        }

        const root = createRoot(this.contentContainer$el.get(0));

        root.render(
            React.createElement(ChangePlanContent, {
                currentPlanType: this._currentPlanType,
                currentBillingCycle: this._currentBillingCycle,
                workspaceUsage: this._workspaceUsage,
                onConfirm: this.onConfirmTriggered.bind(this),
                onCancel: this.onCancelTriggered.bind(this),
                onCancelSubscription: this._onCancelSubscription ? this.onCancelSubscriptionTriggered.bind(this) : undefined,
                i18nModule: this._i18nModule,
                useEditorTheme: true
            })
        );

        this._reactRoot = root;
    },

    addReactWidget: function() {
        this._renderReactComponent();
    },

    onAfterPageShow: function() {
        this.addReactWidget();
    },

    afterRender: function() {
        OptionPopupView.prototype.afterRender.call(this);
    }
});

export default ChangePlanPopupView;
